/** @file QUAD_HANDLE_SPOTS: where each resize handle sits on a quad, in quad parameters (u right, v down). */

/**
 * `[u, v]` per resize handle on the drawn quad `[tl, tr, br, bl]`: 0..3 the corners tl, tr, br, bl, 4..7 the edge
 * midpoints top, right, bottom, left (handle 8, the pivot diamond, sits on the pivot). 0 and 1 are the quad's
 * edges, 0.5 a midpoint.
 */
export const QUAD_HANDLE_SPOTS: readonly (readonly [number, number])[] = [
  [0, 0], [1, 0], [1, 1], [0, 1], [0.5, 0], [1, 0.5], [0.5, 1], [0, 0.5],
];
